import { trpc } from '@/shared/api';

/** 어드민 운영 설정(siteSettings.get) — 카카오톡 채널 주소와 마지막 변경 시각·변경자. */
export const useSiteSettingsQuery = () => trpc.siteSettings.get.useQuery();
